module.exports = __webpack_public_path__ + "static/img/4_1.7a36a176.jpg";